import * as React from 'react';

interface Props {
  item: {
    title: string;
    img: string;
    url: string;
    source: string;
    stock?: string;
    price: number;
    rrp?: number;
  };
}

export default class SearchItem extends React.Component<Props> {
  render() {
    const hasRrp = !!this.props.item.rrp;
    return (
      <a
        className="media has-text-dark"
        href={this.props.item.url}
        target="_blank"
        ref="noopener noreferrer"
      >
        {!!this.props.item.img && (
          <div className="media-left">
            <figure className="image is-64x64">
              <img src={this.props.item.img} />
            </figure>
          </div>
        )}
        <div className="media-content">
          <h6>{this.props.item.title}</h6>
          {this.props.item.stock &&
            <>
              <small>{this.props.item.stock}</small>
              <br />
            </>
          }
          <small className="has-text-grey">via {this.props.item.source}</small>
        </div>
        <div className="media-right has-text-right">
          <div className="tags has-addons">
            {hasRrp &&
              <span className="tag is-primary is-light">
                <del>£{this.props.item.rrp.toFixed(2)}</del>
              </span>
            }
            {this.props.item.price !== 0 ?
            <span className={`tag has-text-weight-bold ${hasRrp ? 'is-primary' : 'is-primary is-light'}`}>
              £{this.props.item.price.toFixed(2)}
            </span>
            :
            <span className="tag is-warning">Visit website for price</span>
            }
          </div>
          {hasRrp &&
            <div className="tag is-success is-light is-rounded">Save £{(this.props.item.rrp - this.props.item.price).toFixed(2)}</div>
          }
        </div>
      </a>
    );
  }
}
